// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20l5D","inner":"styles_inner__2Z27h","right":"styles_right__2KhKj","close":"styles_close__r5vxS","footer":"styles_footer__29GFN"};